import { t } from "@lingui/macro"
import { match } from "ts-pattern"
import { farePriceLabelV4 } from "../../../../../components/Prices/prices-utils-v4"
import { FarePriceLabel } from "./FarePriceLabel"

export const FarePriceLabelV4: FarePriceLabel = ({ price }) =>
    match(price)
        .with({ type: "loading" }, () => t`Total price`)
        .with({ type: "loaded" }, ({ response }) => farePriceLabelV4(response.price))
        .exhaustive()
